import Buy from 'api/models/Engines/Buy';

const dataToCopyTextMapper = (data: Buy[]) => {
	return data
		.map((item) => `${item.good_name} \r\n Тип: ${item.good_type} \r\n Ключ: ${item.key}`)
		.join('\r\n\r\n');
};

export default dataToCopyTextMapper;
